"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ListItemBase = _interopRequireDefault(require("./ListItemBase"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ListItem is responsible for rendering icon or a bullet as side item
 */const ListItem = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    tokens,
    variant,
    children,
    title,
    ...listItemProps
  } = _ref;
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('List', tokens, variant);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemBase.default, {
    tokens: themeTokens,
    ref: ref,
    ...listItemProps,
    title: title,
    children: children
  });
});
ListItem.displayName = 'ListItem';
ListItem.propTypes = {
  variant: _utils.variantProp.propType,
  ..._ListItemBase.default.propTypes
};
var _default = exports.default = ListItem;